import { render, staticRenderFns } from "./PickupDetailsCard.vue?vue&type=template&id=770e2dca&scoped=true&"
import script from "./PickupDetailsCard.vue?vue&type=script&lang=js&"
export * from "./PickupDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./PickupDetailsCard.vue?vue&type=style&index=0&id=770e2dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e2dca",
  null
  
)

export default component.exports